module.exports = {
    customer: 'gartenkultur',
    assets: { logo: 'logo.svg' }
    
};